//dependencies
import { format, startOfMonth } from "date-fns";
import { useEffect, useState } from "react";

//utils
import coerceToDateObject from "./coerceToDateObject";

export const useActiveMonth = (value: string | Date) => {
	value = value ? coerceToDateObject(value) : new Date();
	const valueCopy = new Date(value.valueOf());

	const [activeMonth, setActiveMonth] = useState(startOfMonth(valueCopy));

	return [activeMonth, setActiveMonth] as const;
};

export const useTextInputDate = (value: string | Date, config: string) => {
	let dateValueForInputText = "";
	try {
		const dateObject = coerceToDateObject(value);
		if (dateObject) {
			dateValueForInputText = format(dateObject, config);
		}
	} catch (err) {
		dateValueForInputText = "";
	}

	const [inputValue, setInputValue] = useState(dateValueForInputText);

	useEffect(() => {
		if (!value || value === "") {
			setInputValue("");
		} else {
			const dateObject = coerceToDateObject(value);
			if (dateObject) {
				setInputValue(format(dateObject, config));
			}
		}
	}, [value]);

	return [inputValue, setInputValue] as const;
};
